export default __webpack_public_path__ + "static/media/sense.8f976a5f.svg";